import { Pipe, PipeTransform } from '@angular/core';
import { PriceConfig } from '@ui/orders/graphql';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { selectLookBookProductsInBasket } from '@ui/products/shopping-cart-back/actions/selector';
import { AvailableCurrenciesService } from 'ZalamoLibrary/src/lib/zalamo/currencies/available-currencies.service';
import { LookBookPriceWithFilesCalculatorService } from '@ui/products/shopping-cart-back/pipe/lookbook/look-book-price-with-files-calculator.service';

@Pipe({
    name: 'lookBookPrice',
    standalone: false
})
export class LookBookPricePipe implements PipeTransform {
  constructor(
    private store: Store,
    private availableCurrencies: AvailableCurrenciesService,
    private lookBookPriceWithFilesCalculatorService: LookBookPriceWithFilesCalculatorService
  ) {}

  transform(lookBookProductConfigId: string): Observable<Array<PriceConfig>> {
    return this.store.pipe(select(selectLookBookProductsInBasket)).pipe(
      switchMap((lookBookProductsInBasket) => {
        const productInBasket = lookBookProductsInBasket.find(
          (value) => value.lookBookProductConfigId === lookBookProductConfigId
        );
        const productIndex = lookBookProductsInBasket.findIndex(
          (value) => value.lookBookProductConfigId === lookBookProductConfigId
        );
        return this.lookBookPriceWithFilesCalculatorService.calculatePriceForLookBookProduct(
          productInBasket,
          productIndex,
          true
        );
      })
    );
  }
}
